import { render, staticRenderFns } from "./ObjectFiles.vue?vue&type=template&id=374cf9e7&"
import script from "./ObjectFiles.vue?vue&type=script&lang=js&"
export * from "./ObjectFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports